import User from './repositories/UserRepository.js'
import Cases from './repositories/CaseRepository.js'
import CasesV2 from './repositoriesV2/CaseRepository.js'
import Note from './repositories/NoteRepository.js'
import Consultation from './repositories/ConsultationRepository.js'
import Medication from './repositories/MedicationRepository.js'
import Recommendation from './repositories/RecommendationRepository.js'
import Diagnosis from './repositories/DiagnosisRepository.js'
import Medicine from './repositories/MedicineRepository.js'
import Examination from './repositories/ExaminationRepository.js'
import Specialization from './repositories/SpecializationRepository.js'
import Pms from './repositories/PmsRepository.js'
import Request from './repositories/RequestRepository.js'
import Allergy from './repositories/AllergyRepository.js'
import Schedule from './repositories/ScheduleRepository.js'
import Password from './repositories/PasswordRepository.js'
import PmsV2 from './repositoriesV2/PmsRepository.js'
import UserV2 from './repositoriesV2/UserRepository'
import CallRepository from './repositories/CallRepository.js'
import TextReplacementRepository from './repositoriesV2/TextReplacementRepository.js'

const repositories = {
  User: User,
  Cases: Cases,
  CasesV2: CasesV2,
  Note: Note,
  Consultation: Consultation,
  Medication: Medication,
  Recommendation: Recommendation,
  Diagnosis: Diagnosis,
  Medicine: Medicine,
  Examination: Examination,
  Specialization: Specialization,
  Pms: Pms,
  Request: Request,
  Allergy: Allergy,
  Schedule: Schedule,
  Password: Password,
  PmsV2: PmsV2,
  UserV2: UserV2,
  Call: CallRepository,
  textReplacement: TextReplacementRepository
}
export default {
  get: name => repositories[name]
};